enum Mutations {
  SET_IS_PROMO_CODE_VALID = 'setPromoCodeValid',
}

export default Mutations
